'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var jsUtils = require('@swiggy-private/js-utils');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var Digit = require('../../Digit-BQG2kZ_U.js');
var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const OTPInputContainer = styled__default.default.div({
    position: "relative",
});
const SplitOTPBoxesContainer = styled__default.default.div({
    display: "flex",
    justifyContent: "center",
});
const TextInputHidden = styled__default.default.input({
    opacity: 0,
    position: "absolute",
    width: "100%",
    top: 0,
});
const StyledErrorMessage = styled__default.default.div(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
    minHeight: theme.spacing.xxLarge,
    textAlign: "center",
}));

const useForwardedRef = (ref) => {
    const targetRef = React.useRef(null);
    React.useEffect(() => {
        if (!ref)
            return;
        if (typeof ref === "function") {
            ref(targetRef.current);
        }
        else {
            ref.current = targetRef.current;
        }
    }, [ref]);
    return targetRef;
};

const OTPInput = React.forwardRef(({ value, onChange, length, errorMsg, testId, ariaLabel, isDisabled }, ref) => {
    const [focused, setFocused] = React.useState(false);
    const isError = React.useMemo(() => !jsUtils.isEmpty(errorMsg), [errorMsg]);
    const otpRef = useForwardedRef(ref);
    const digitArr = React.useMemo(() => {
        return Array.from(Array(length));
    }, [length]);
    const onFocus = React.useCallback(() => {
        setFocused(true);
    }, []);
    const onBlur = React.useCallback(() => {
        setFocused(false);
    }, []);
    const onTextChange = React.useCallback((e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e.currentTarget.value);
    }, [onChange]);
    const setFocus = React.useCallback(() => {
        var _a;
        (_a = otpRef === null || otpRef === void 0 ? void 0 : otpRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [otpRef]);
    return (React__default.default.createElement(OTPInputContainer, { onClick: setFocus },
        React__default.default.createElement(SplitOTPBoxesContainer, { "aria-hidden": "true" }, digitArr.map((_, index) => (React__default.default.createElement(Digit.Digit, { key: index, index: index, value: value, maxLength: length, error: isError, isFocussed: focused })))),
        React__default.default.createElement(TextInputHidden, { value: value, maxLength: length, disabled: isDisabled, "aria-label": ariaLabel, ref: otpRef, onFocus: onFocus, onBlur: onBlur, onChange: onTextChange, "aria-invalid": isError, type: "text", inputMode: "numeric", autoComplete: "one-time-code", name: "otp-input-box", "data-testid": testId, pattern: `\\d{${length}}`, autoFocus: true }),
        React__default.default.createElement(StyledErrorMessage, null,
            React__default.default.createElement(Text.Text, { color: "negative", variant: "V2.body3.neutral.medium", maxLines: 2 }, errorMsg))));
});
var index = React.memo(OTPInput);

exports.default = index;
//# sourceMappingURL=index.js.map
